

































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

// Model
import GeofenceModel from '@/_models/GeofenceModel'

// Interface
import { IDropdownList } from '@/_interfaces'

// Helpers
import { Filter } from '@/_utils/filter'
import { isCardOff } from '@/_utils/card'

// Common
import NotFound from '@/components/common/NotFound.vue'
import TableSortMixin from '@/components/mixins/TableSortMixin.vue'

// Shared
import LastUpdatedJbox from '@/components/shared/LastUpdatedJbox.vue'
import TablePagination from '@/components/shared/TablePagination.vue'
import UserType from '@/components/shared/UserType.vue'
import StateStatus from '@/components/shared/StateStatus.vue'
import DropdownSearch from '@/components/common/buttons/DropdownSearch.vue'
import LabelButtonInput from '@/components/common/buttons/LabelButtonInput.vue'

@Component({
  components: {
    TablePagination,
    NotFound,
    LastUpdatedJbox,
    UserType,
    StateStatus,
    LabelButtonInput,
    DropdownSearch,
  },
})
export default class MonitorList extends mixins(TableSortMixin) {
  @Prop() parent!: any
  isFirstLoadMonitor: boolean = true
  filterUtilTableSort: any = new Filter('filter_monitor_list_table_sort')

  isCardOff: any = isCardOff
  numofPage: number = 0
  pageFilters: any = {
    currentPage: 1,
    perPage: 10,
    selectedFilter: 'name',
    searchQuery: '',
    searchSubQuery: '',
  }

  filedNameLUT: any = {
    san_id: 'label.san_id',
    name: 'label.username',
  }

  dropdownList: IDropdownList[] = [
    {
      value: 'san_id',
      label: this.$t('label.san_id').toString(),
    },
    {
      value: 'name',
      label: this.$t('label.username').toString(),
    },
  ]

  get geofencesFilter() {
    return this.parent.geofences.filter(
      (geofence: GeofenceModel) =>
        geofence.name.toString().toLowerCase().indexOf(this.pageFilters.searchQuery.toLowerCase()) >= 0
    )
  }

  get monitors() {
    const monitors = this.$store.state.geofences.item.monitor
    this.numofPage = Math.ceil(monitors.length / this.pageFilters.perPage)
    return monitors
  }

  get monitorsFilter() {
    return this.monitors.filter(
      monitor =>
        monitor[this.pageFilters.selectedFilter]
          ?.toString()
          .toLowerCase()
          .indexOf(this.pageFilters.searchSubQuery.toLowerCase()) >= 0
    )
  }

  // methods
  convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  isOnGeofence(currentLocationId: string) {
    return currentLocationId === this.parent.seletedGeofence._id ? 'IN' : 'OUT'
  }

  handleSelectGeofence(selected: GeofenceModel) {
    if (!selected) {
      return
    }

    this.parent.filterUtilList.save(selected._id)
    this.parent.isChangedGeofence = true

    const routeGeofenceId = this.$route.params.geofence_id
    const path = routeGeofenceId ? this.$route.path.split('/')[0] : this.$route.path
    history.pushState({}, this.$route.meta?.title ?? '', path + '/' + selected._id)

    this.parent.messsages = []
    this.parent.setSelectedGeofence(selected)
    this.parent.getAutoRefeshMonitor(selected)
  }

  created() {
    this.tableRef = 'geofenceMonitorList'
  }
}
